import React, { useState, useEffect, useRef } from "react";

import { FaAngleUp } from "react-icons/fa6";
import { Divider } from "@mui/material";
import { Button } from "flowbite-react";

import dow1 from "../../assets/images/NewEvent/dow1.webp";
import cli from "../../assets/images/NewEvent/cli.svg";
import goo from "../../assets/images/NewEvent/goo.svg";
import appp from "../../assets/images/NewEvent/appp.svg";
import get1 from "../../assets/images/NewEvent/get1.svg";
import pl1 from "../../assets/images/NewEvent/pl1.svg";
import donw1 from "../../assets/images/NewEvent/donw1.svg";
import sto from "../../assets/images/NewEvent/sto.svg";

export default function DownLoad() {
  const [config, setConfig] = useState(null);
  const [selectedWindowsBit, setSelectedWindowsBit] = useState("64-bit");
  const [selectedMacOSBit, setSelectedMacOSBit] = useState("64-bit");

  const featuresRef = useRef(null);

  useEffect(() => {
    const version = "1.0.3";
    fetch(`/config.json?v=${version}`)
      .then((response) => response.json())
      .then((data) => setConfig(data))
      .catch((error) => console.error("Error loading config:", error));
  }, []);

  if (!config) {
    return <div>Loading...</div>;
  }

  const downloadLinks = config.downloadLinks;

  const handleExperienceClick = () => {
    if (featuresRef.current) {
      featuresRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleWindowsDownload = () => {
    const link = downloadLinks.Windows[selectedWindowsBit];
    if (link) {
      window.open(link, "_blank");
    }
  };

  const handleMacOSDownload = () => {
    const link = downloadLinks.MacOS;
    if (link) {
      window.open(link, "_blank");
    }
  };

  return (
    <div>
      {/* Header Section */}
      <div className="bg-tai1 py-20 md:pt-20">
        <div className="container mx-auto flex flex-col lg:flex-row items-center gap-4 justify-between px-4 md:px-[130px] md:py-[60px]">
          <div className="w-full text-center lg:text-left md:text-center flex gap-4 flex-col">
            <div>
              <h1 className="text-[#053CC8] font-semibold text-[64px]">
                BlueRise
              </h1>
            </div>
            <div>
              <p className="text-[#333333] font-normal text-[20px] ">
                Giải pháp chuyển đổi số toàn diện dành cho giáo dục
              </p>
            </div>

            <div className="flex items-center justify-center md:justify-center lg:justify-start">
              <button
                onClick={handleExperienceClick}
                className="bg-blue-600 text-white text-[16px] font-medium rounded-lg shadow-md hover:bg-pa px-4 py-4 w-[200px]"
              >
                Trải nghiệm ngay+
              </button>
            </div>
          </div>
          <div className="w-full relative mt-3">
            <img
              src={dow1}
              alt="BlueRise devices"
              className="w-full h-auto z-20 relative"
            />
            <img src={cli} alt="cl" className="absolute -top-12 right-0 z-10" />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div ref={featuresRef} className="bg-[#F4F8FF]">
        <div className="container mx-auto px-4 md:px-[130px] md:py-[56px]">
          <h2 className="text-center text-[#0430A0] font-semibold text-[40px]">
            Các công cụ của BlueRise
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col w-full gap-4">
              {/* Card 1: Website */}
              <div className="bg-white shadow-custom-light3 rounded-[24px] px-[32px] py-[40px]">
                <h3 className="text-[#0430A0] font-semibold text-[32px]">
                  BlueRise dành cho website
                </h3>
                <p className="text-gray-600 mt-2">
                  Quản lý giáo dục trực tuyến dễ dàng và hiệu quả.
                </p>
                <div className="flex items-center justify-center mt-2 w-full">
                  <Button
                    href="https://erp.bluerise.com.vn/"
                    target="_blank"
                    className="text-[#053CC8] flex items-center w-full rounded-[8px] bg-[#E6ECFA] hover:bg-gray-100 justify-center px-[16px] py-[16px]"
                  >
                    erp.bluerise.com.vn →
                  </Button>
                </div>
              </div>

              {/* Card 2: Mobile */}
              <div className="bg-white rounded-[24px] px-[32px] py-[40px] shadow-custom-light3">
                <h3 className="text-[#0430A0] font-semibold text-[30px] w-full">
                  BlueRise dành cho di động
                </h3>
                <p className="text-gray-600 mt-2">
                  Truy cập mọi lúc, mọi nơi trên điện thoại.
                </p>
                <div className="mt-4 flex flex-col sm:flex-row md:flex-col gap-4">
                  <Button
                    href="https://play.google.com/store/apps/details?id=com.bluerisehs.app"
                    target="_blank"
                    className="bg-white shadow-custom-light3 border-2 hover:bg-slate-100 rounded-[68px] px-[16px] py-[12px] border-solid border-[#E2E2E2] flex items-center justify-center gap-6"
                  >
                    <div className="flex items-center gap-4">
                      <img
                        src={goo}
                        alt="Google Play"
                        className="w-[28px] h-[31px]"
                      />
                      <div>
                        <img src={get1} alt="ge" />
                        <img src={pl1} alt="pl" className="mt-1" />
                      </div>
                    </div>
                  </Button>
                  <Button
                    href="https://apps.apple.com/vn/app/bluerisehs/id6759903432?l=vi"
                    target="_blank"
                    className="bg-white border-2 hover:bg-slate-100 shadow-custom-light3 border-solid border-[#E2E2E2] rounded-[68px] px-[16px] gap-4 py-[12px] flex items-center justify-center"
                  >
                    <div className="flex items-center gap-4">
                      <img
                        src={appp}
                        alt="App Store"
                        className="w-[28px] h-[34px]"
                      />
                      <div className="flex flex-col gap-1">
                        <img src={donw1} alt="do" />
                        <img src={sto} alt="ss" />
                      </div>
                    </div>
                  </Button>
                </div>
              </div>
            </div>

            {/* Card 3: Desktop */}
            <div className="bg-white shadow-custom-light3 rounded-[24px] px-[32px] py-[40px]">
              <h3 className="text-[#0430A0] font-semibold text-[32px] text-center w-full">
                BlueRise dành cho máy tính
              </h3>
              <p className="text-gray-600 mt-2 text-center">
                Ứng dụng mạnh mẽ cho quản lý trường học.
              </p>
              <div className="flex flex-col gap-6 mt-3">
                {/* Phần tải xuống cho Windows */}
                <div className="flex flex-col gap-2">
                  <label className="text-[#0430A0] font-medium">Windows</label>
                  <div
                    className="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                    value={selectedWindowsBit}
                    onChange={(e) => setSelectedWindowsBit(e.target.value)}
                  >
                    <option value="64-bit">64-bit</option>
                  </div>
                  <button
                    className="w-full bg-blue-600 text-white rounded-lg shadow-md hover:bg-pa px-[16px] py-[16px]"
                    onClick={handleWindowsDownload}
                  >
                    Tải xuống cho Windows
                  </button>
                </div>

                {/* Phần tải xuống cho MacOS */}
                <div className="flex flex-col gap-2">
                  <label className="text-[#0430A0] font-medium">MacOS</label>
                  <button
                    className="w-full bg-blue-600 text-white rounded-lg shadow-md hover:bg-pa px-[16px] py-[16px]"
                    onClick={handleMacOSDownload}
                  >
                    Tải xuống cho MacOS
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <FAQSection />

      {/* Footer Section */}
      <footer className="bg-bup py-12">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-white font-semibold text-[40px] mb-6">
            Chọn một cách tốt hơn để quản lý
          </h2>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <button
              onClick={handleExperienceClick}
              className="bg-white text-blue-600 border border-blue-600 rounded-lg px-6 py-2 hover:bg-blue-100"
            >
              TẢI XUỐNG PHẦN MỀM BLUERISE
            </button>
            <a
              href="https://m.me/HeSinhThaiGiaoDucBlueRise"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                className="bg-bup text-white border border-white
            hover:bg-pa rounded-lg px-6 py-2"
              >
                LIÊN HỆ TỚI CHĂM SÓC KHÁCH HÀNG
              </button>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

// Component FAQSection giữ nguyên như code gốc
const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "Tôi có thể tải phần mềm này ở đâu?",
      answer:
        "Bạn có thể tải phần mềm trực tiếp từ trang web chính thức của chúng tôi. Ngoài ra, chúng tôi còn có phiên bản dành cho Windows và ứng dụng di động.",
    },
    {
      question: "Phần mềm này có trên Windows không? Tôi tải ở đâu?",
      answer:
        "Có, phần mềm BlueRise hỗ trợ Windows. Bạn có thể tải xuống từ nút 'Tải xuống' trong phần Features hoặc truy cập trang web chính thức.",
    },
    {
      question: "Ứng dụng di động có trên App Store hoặc Google Play không?",
      answer:
        "Có, ứng dụng BlueRise hiện có trên cả Google Play và App Store. Bạn có thể tìm thấy link tải trong phần Features.",
    },
  ];

  return (
    <div className="py-12 bg-gray-100">
      <div className="container mx-auto px-4 grid grid-cols-1 lg:grid-cols-12 gap-8 md:px-[130px] md:py-[56px]">
        <div className="md:col-span-3">
          <h2 className="text-[#1F1F1F] font-semibold text-[32px]">
            Vẫn còn câu hỏi? Chúng tôi có câu trả lời.
          </h2>
        </div>
        <div className="flex flex-col gap-2 w-full md:col-span-9">
          {faqItems.map((faq, index) => (
            <div key={index} className="p-4 flex flex-col gap-3">
              <Divider />
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <p className="text-[18px] font-medium">{faq.question}</p>
                <FaAngleUp
                  className={`w-6 h-6 transform transition-transform ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </div>
              {openIndex === index && (
                <div className="mt-2 text-gray-600">{faq.answer}</div>
              )}
              <Divider />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
